@if (customerQuestionnaireService.showBanner && isQuestionnaireLoaded && !showCVRNotification()) {
<div
    class="customer-banner width-p-99 height-48"
    [ngClass]="{
        'is-never-started-banner': customerQuestionnaireService.showStartBanner(),
        'is-resumed-banner': customerQuestionnaireService.showResumeBanner()
    }"
>
    <div class="customer-banner-content">
        <span class="ds-icon-error_outline fs-20 error-primary m-l-8 line-height-08 ng-star-inserted"></span>
        @if (customerQuestionnaireService.showStartBanner()) {
        <div class="customer-banner-content-message fs-14 m-t-2">
            To finalize your threat profile, please complete the
            <a [routerLink]="'/cq/questionnaire'">Customer Questionnaire</a>
        </div>
        } @if (customerQuestionnaireService.showResumeBanner()) {
        <div class="customer-banner-content-message fs-14">
            For a more specific threat intel model for your MDR service, please complete the full
            <a [routerLink]="'/cq/questionnaire'">Customer Questionnaire</a>
        </div>
        } @if (customerQuestionnaireService.showResumeBanner()) {
        <div class="m-r-15 fr close-icon-div">
            <mat-icon
                class="close-icon m-r-5 m-l-10"
                (click)="onCloseBannerClicked()"
                >close
            </mat-icon>
        </div>
        }
    </div>
</div>
} @if (showCVRNotification()) {
<div
    class="customer-banner width-p-99 height-48 cvr-banner"
    [@inOutAnimation]
>
    <div class="customer-banner-content">
        <span class="ds-icon-notification_info fs-20 error-primary m-l-8 line-height-08 ng-star-inserted"></span>
        <div class="customer-banner-content-message fs-14">
            Please review and respond to requests in the
            <a
                id="cvr_link"
                [routerLink]="'/customer-verification-requests/browse'"
                >Verification Requests</a
            >
        </div>
        <div class="m-r-15 fr close-icon-div">
            <mat-icon
                class="close-icon m-r-5 m-l-10"
                (click)="onCloseCVRBannerClicked()"
                >close
            </mat-icon>
        </div>
    </div>
</div>
} @if (showBreachWarranty()) {
<div
    class="customer-banner height-48 width-p-99"
    [@inOutAnimation]
>
    <div class="customer-banner-content d-flex align-center">
        <div><span class="ds-icon-notification_info fs-20 error-primary m-l-8 line-height-08 ng-star-inserted"></span></div>
        <div class="customer-banner-content-message fs-14">
            For the Breach Warranty Add-on, please acknowledge the prerequisites on the
            <a
                id="breach_link"
                [routerLink]="'/breach-warranty/browse'"
                >Breach Warranty page</a
            >
        </div>
    </div>
</div>
}
